import { createContext, useContext } from "react";
import { useLoad } from "../hooks/useLoad";
import Load from "../components/shared/Load";

const LoadContext = createContext();

export const LoadProvider = ({ children }) => {
    const load = useLoad();
    return <LoadContext.Provider value={load}>
        {children}
        {load.load?<Load />:null}
    </LoadContext.Provider>;
};

export const useLoadContext = () => useContext(LoadContext);